var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loadding),expression:"loadding"}],staticClass:"pdf",attrs:{"element-loading-text":"加载中","element-loading-spinner":"el-icon-loading"}},_vm._l((_vm.pages),function(page){return _c('canvas',{key:page,staticClass:"first-area",attrs:{"id":'the-canvas'+page}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bb16602e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/infoCollection/components/pdf.vue
// module id = null
// module chunks = 